import React from 'react';
import PropTypes from 'prop-types';

import { DODGER_BLUE } from '@constant/colors';

const CheckCircleLight = ({ className, color }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="31" stroke={color} strokeWidth="2" />
    <path
      d="M18.667 32.667L29.333 42l16-17.333"
      stroke={color}
      strokeWidth="2.667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CheckCircleLight.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

CheckCircleLight.defaultProps = {
  color: DODGER_BLUE,
};

export default CheckCircleLight;
